import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import InputText from 'components/input-text';
import Loader from 'components/loader';
import './styles.scss';

const WAIT_INTERVAL = 700;
const ENTER_KEY = 13;
class TextSearch extends PureComponent {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = {
            text: props.value,
            waiting: false,
        };
    }

    componentDidMount() {
        this.timer = null;
    }

    static getDerivedStateFromProps(props, state) {
        const { value = '' } = props;
        const { text, waiting } = state;
        if (!waiting && value !== text) {
            return {
                text: value,
            };
        }
        return null;
    }

    handleClear = () => {
        this.setState({ text: '', waiting: true }, () => {
            this.triggerChange();
        });
    };

    triggerChange = () => {
        const { text } = this.state;
        const { onChange } = this.props;
        this.setState({
            waiting: false,
        });
        onChange(text);
    };

    handleChange = (text) => {
        clearTimeout(this.timer);
        this.setState({
            text,
            waiting: true,
        });
        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    };

    handleKeyDown = (e) => {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange();
        }
    };

    focusTextInput() {
        this.textInput.current.focusTextInput();
    }

    clearInput() {
        this.textInput.current.clearInput();
    }

    render() {
        const { className = '', placeholder = '', searching, ...rest } = this.props;
        const { text, waiting } = this.state;
        const inputClass = `input-text-search-wrapper ${className}`;

        return (
            <div className={inputClass}>
                <InputText
                    {...rest}
                    ref={this.textInput}
                    className="input-text-search"
                    placeholder={placeholder}
                    value={text}
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyDown}
                    onClearClick={this.handleClear}
                    showIcon={!searching}
                />
                <div className="input-text-search-action">
                    {!waiting && searching && <Loader size="small" />}
                </div>
            </div>
        );
    }
}

TextSearch.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    searching: PropTypes.bool,
    className: PropTypes.string,
};

export default TextSearch;
